import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_STAGES_STUDY_LIST } from "./types";


export const getStagesStudy = () => async (dispatch) => {
  try {
    const { data } = await api.get('/study_steps');
    dispatch({ type: SET_STAGES_STUDY_LIST, payload: data });
  } catch (ERR) {
  }
}

export const createStagesStudy = (reqData, closeModal) => async (dispatch) => {
  let success;
  try {
    await api.post(`/study_steps`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getStagesStudy());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  } finally {
    return success;
  }
}

export const updateStagesStudy = ({ f_studysteps, ...reqData }, closeModal) => async (dispatch) => {
  let success;
  try {
    await api.put(`/study_steps/${f_studysteps}`, reqData);
    success = true;
    createNotification('success', 'Успешно');
    await dispatch(getStagesStudy());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  } finally {
    return success;
  }
}

export const deleteStagesStudy = (id) => async (dispatch) => {
  try {
    await api.delete(`/study_steps/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getStagesStudy());
  } catch (error) {
    const message = error.response?.data?.error || 'Ошибка';
    createNotification('error', message);
  }
}
